// extracted by mini-css-extract-plugin
module.exports = {"container":"filteredViewMessage_container__H5wdG","content":"filteredViewMessage_content__uY4o_","message":"filteredViewMessage_message__kiYX_"};